import React, { PureComponent } from 'react';
import styled from '@emotion/styled';
import { Media } from '..';

class HeroVideoComponent extends PureComponent {
    componentDidMount() {
        this.imageOnLoad = () => {
            if (document.getElementById('CloneWrapper')) {
                document
                    .getElementById('CloneWrapper')
                    .classList.add('fadeout');
            }
        };
    }
    imageOnLoad() {}
    render() {
        const { color, video, localVideo } = this.props;
        return (
            <HeroVideo
                /*removed innerRef*/ ref={el => (this.hero = el)}
                id="HeroVideo"
                bgcolor={color && color.hex}
                bgimage={video && video.thumbnailUrl}>
                <Media
                    video={{
                        ...video,
                        localVideo: localVideo,
                    }}
                    loop={true}
                    onLoad={this.imageOnLoad}
                />
            </HeroVideo>
        );
    }
}

const HeroVideo = styled.div`
    background-color: ${props => props.bgcolor};
    overflow: hidden;
    &::before {
        content: '';
        width: 1px;
        margin-left: -1px;
        float: left;
        height: 0;
        padding-top: 66.66666666%;
    }
    &::after {
        content: '';
        display: table;
        clear: both;
    }

    position: absolute;

    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 100%;
    height: 100%;

    video {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        min-width: 101%;
        min-height: 101%;
        max-width: initial;
        opacity: 1;
        width: auto;
        height: auto;
        z-index: -100;
    }
`;

export default HeroVideoComponent;
